<template>
  <div v-if="getCurrentUserIsAbleToRead" class="app-toolbar-wrapper">
    <v-flex>
      <v-row no-gutters justify="space-between" class="mt-1 mb-4">
        <Breadcrumb />
        <ClockComponent />
      </v-row>
      <v-row class="app-toolbar-divider">
        <v-divider dark />
      </v-row>
    </v-flex>
  </div>
</template>

<script setup lang="ts">
import ClockComponent from '@/components/common/ClockComponent/ClockComponent.vue';
import Breadcrumb from '@/components/common/Breadcrumb/Breadcrumb.vue';

import './styles/application-toolbar.scss';
import { useRoute } from 'vue-router/composables';
import useStore from '@/utils/store/common';

const route = useRoute();
const store = useStore();

function getCurrentUserIsAbleToRead() {
  const featureName = route?.meta?.text;
  return store.getters['permissions/getCurrentUserIsAbleTo']('read', featureName) || store.getters['permissions/getCurrentUserIsAbleTo']('write', featureName);
}

</script>
